// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TrustpilotCard__card___ioYTC{padding:24px}.TrustpilotCard__header___25Q04{display:flex;align-items:center;justify-content:space-between;margin-bottom:24px}.TrustpilotCard__thumbnail___129FH{width:32px;height:32px;margin-right:16px;border-radius:16px}.TrustpilotCard__profile___EqGDZ{display:flex;align-items:center;width:100%}.TrustpilotCard__icon___355gs{width:22px;height:22px}.TrustpilotCard__info___1WTuk{color:#807c6c}.TrustpilotCard__info___1WTuk strong{color:inherit;font-weight:400;font-size:16px;line-height:24px;color:#564f34}.TrustpilotCard__score___2MSZp{display:flex;margin-top:25px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"card": "TrustpilotCard__card___ioYTC",
	"header": "TrustpilotCard__header___25Q04",
	"thumbnail": "TrustpilotCard__thumbnail___129FH",
	"profile": "TrustpilotCard__profile___EqGDZ",
	"icon": "TrustpilotCard__icon___355gs",
	"info": "TrustpilotCard__info___1WTuk",
	"score": "TrustpilotCard__score___2MSZp"
};
module.exports = ___CSS_LOADER_EXPORT___;
